function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5 0a6.5 6.5 0 110 13h-10a6.5 6.5 0 110-13h10zm-10 1a5.5 5.5 0 00-5.4 6.4v.2a5.5 5.5 0 00.2.8 5.5 5.5 0 00.3.7h.1v.2-.1l.1.2v-.1.1l.1.2v-.2.2a5.5 5.5 0 00.3.4v-.1.1l.2.1h-.1l.1.1.2.2-.1-.1.1.1.1.1.2.1h-.1l.2.1h-.1.1l.1.1.1.1.2.1h-.1.2-.1l.1.1.1.1h.1l.1.1h.1l.2.2-.1-.1.2.1h.2-.1a5.5 5.5 0 00.5.2h.1-.1.2-.1l.2.1H5a5.5 5.5 0 001.5.2 5.5 5.5 0 000-11zm10 0H10a6.5 6.5 0 010 11h6.5a5.5 5.5 0 00.2-11h-.2z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 23,
    height: 13
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/toggle-off.39733b69.svg";
export { SvgComponent as ReactComponent };